import { Text } from "@bookingcom/bui-react";
import React from "react";
import { useSelector } from "react-redux";
import { getSearchCriteria } from "../../../../store/searchCriteria/selectors.js";
import { t, useI18n } from "@bookingcom/lingojs-react";
const companyName = "Booking.com";
const FlightAvailableSeats = ({ flight }) => {
    const i18n = useI18n();
    const searchCriteria = useSelector(getSearchCriteria);
    const { adults, children } = searchCriteria;
    const travellersCount = adults + children.length;
    if (flight.seatAvailability && flight.seatAvailability.numberOfSeatsAvailable >= travellersCount) {
        const translationVariables = {
            num_left: flight.seatAvailability.numberOfSeatsAvailable,
            b_companyname: companyName
        };
        return (React.createElement(Text, { variant: "small_1", color: "callout" }, i18n.trans(t("flights_sr_last_left", {
            variables: translationVariables
        }))));
    }
    return null;
};
export default FlightAvailableSeats;
